import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Rocket } from 'lucide-react';
import { Button } from 'components/ui/button';

const AnalysisEntityDetail = () => {
  const { entityType, entitySlug } = useParams();
  const navigate = useNavigate();

  // Helper to convert slug back to a displayable format if needed, though ID is better
  const displayName = entitySlug ? entitySlug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'Unknown Entity';

  return (
    <div className="w-full h-full flex flex-col bg-slate-50 min-h-screen">
      <div className="px-8 py-6 bg-white border-b border-slate-200">
        <Button 
          variant="ghost" 
          className="mb-4 text-slate-500 hover:text-slate-900 -ml-4"
          onClick={() => navigate('/explore/analysis')}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Analysis
        </Button>
        <h1 className="text-2xl font-semibold text-gray-900 m-0 mb-1 tracking-tight">
          {displayName}
        </h1>
        <p className="text-sm text-gray-500 max-w-3xl">
          Detailed benchmarking analysis for {entityType} with ID {entitySlug}.
        </p>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="flex flex-col items-center justify-center text-center max-w-md">
          <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center mb-6 border border-blue-100">
            <Rocket className="w-10 h-10 text-explore" />
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">
            Detailed Analysis Coming Soon
          </h2>
          <p className="text-slate-500">
            We are working hard to bring you comprehensive benchmarking, deep-dive statistics, and collaboration insights for this entity. Stay tuned!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisEntityDetail;
